export default "__VITE_ASSET__CHgRIMO4__"